<template>
  <Dialog
   width="562px"
   class="agreementDialog"
   :visible.sync="visible"
   :modal="false"
   :show-close="false"
   append-to-body
  >
      <template #title>
        <h1>用户信息保护及隐私政策</h1>
        <button
          type="button"
          aria-label="Close"
          class="el-dialog__headerbtn"
          @click="$emit('update:active',false)"
        ></button>
      </template>
      <div id="agreement">
      <p>版本生效日期：2019年&nbsp;10月&nbsp;24日</p>
      <p>版本更新日期：2019年&nbsp;10月&nbsp;24日</p>
      <p class="indent">
        本《用户信息保护及隐私政策》适用于学而思旗下所有的产品及服务（以下简称“学而思”或“平台”），您通过平台的产品及服务而接入的其他第三方产品或服务除外。
        <strong>
          请您务必在点击同意本政策之前，审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。
          免除或者限制责任的条款将以粗体标识，您应重点阅读。
        </strong>
        如您对政策有任何疑问，可按照本政策列明方式与学而思取得联系。
      </p>
      <p class="indent">
        当您点击确认同意本政策，即表示您已充分阅读、理解且接受本政策的全部内容，并与学而思达成一致，本政策对您及学而思均具有法律约束力。
      </p>
      <h2>一、定义</h2>
      <p>
        1.学而思旗下产品及服务：指学而思网络及技术服务提供者通过下述途径向您提供的产品及服务：
        包括但不限于学而思网站、移动应用、客户端、相关微信开放平台帐号或小程序以及供第三方网站和应用程序使用的学而思软件开发工具包（SDK）和应用程序编程接口（API）、
        未设独立隐私政策的学而思关联公司提供的产品及服务等。
      </p>
      <p>
        2.其他第三方产品或服务：包括但不限于学而思以外的其他交易相对方、第三方网站以及第三方服务提供者为您提供的产品或服务。
      </p>
      <p>
        3.关联公司：指好未来教育集团（TAL Education
        Group）最新上市公司年报披露的好未来教育集团的关联公司。
      </p>
      <p>
        4.合作伙伴：指学而思服务提供过程中涉及的第三方信息系统、支付机构、微信(用于第三方登录的社交平台)，
        以及学而思为实现部分功能、提供更好的客户服务和用户体验而进行合作的其他第三方主体或平台。
      </p>
      <p>
        <strong
          >5.个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</strong
        >
      </p>
      <p>
        <strong>
          6.个人敏感信息：是指一旦泄露、非法提供或滥用可能危人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。
          包括身份证件号码、手机号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。
        </strong>
      </p>
      <p>
        7.个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
      </p>
      <h2>二、用户权利义务</h2>
      <p>1.您理解并同意，享受学而思服务过程中，您需自行准备相关设备且承担如下费用：</p>
      <p class="second">1.1上网设备：包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；</p>
      <p class="second">1.2上网开支：包括并不限于网络接入费、上网设备租用费、手机流量费等；</p>
      <p class="second">
        1.3您理解并保证，您具有享受学而思相关服务的民事行为及责任能力，在使用本服务过程中所提供的资料均具有真实性、准确性，信息完整有效。
        如信息有变动的，应及时进行更新。如因前述原因导致您本人或第三人人身或财产受到损害，学而思不承担责任。
      </p>
      <p>
        2.
        您理解并保证，您在享受学而思相关服务过程中，不违背中华人民共和国大陆地区相关法律法规之规定，不利用学而思服务从事非法行为。您将对您在学而思内发布的所有信息及言论承担所有责任。
      </p>
      <h2>三、平台责任</h2>
      <strong>
        <p>
          1.学而思严格按照本政策及《中华人民共和国网络安全法》、《个人信息安全规范》等相关法律法规的约定收集、使用、储存和分享您的个人信息，
          本政策对个人信息保护相关内容未作明确约定的，以《网络安全法》、《个人信息安全规范》等相关法律法规约定为准。除因学而思存在过错外，
          您自行承担使用学而思服务产生的风险。您如因本人过错或行为而遭受人身损害、财产损害，造成第三方人身损害、财产损害或由第三人造成您人身、
          财产损害的，应当依法向责任主体追究法律责任，学而思不承担相关责任。
        </p>
        <p>
          2.学而思将会尽其商业上的合理努力保障您在学而思及服务中的数据存储安全，但是，学而思并不能就此提供完全保证您的个人信息不会受到任何侵害。
          学而思不对您在学而思及服务中相关数据的删除或储存失败负责，您可根据自身需求自行备份学而思及服务中的相关数据。
        </p>
        <p>
          3.如您违反本政策，学而思保留暂停或终止为您提供学而思各项服务的权利，
          同时有权拒绝提供服务、关闭个人帐号、清除或编辑内容、取消订单、删除各类不符合法律规定或不真实信息内容而无需通知用户。
        </p>
        <p>
          4.您理解并同意：在使用本服务的过程中，可能会遇到不可抗力、技术风险等因素，使本服务发生中断，
          对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更、数据丢失等情形，学而思在法律允许的最大范围内免责：
        </p>
        <p class="second">4.1因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素。</p>
        <p class="second">4.2您或学而思的电脑软件、系统、硬件出现故障或其他原因导致您无法使用学而思。</p>
        <p class="second">
          4.3因电力供应故障、通讯网络故障（包括但不限于电子通讯传达失败或延时、
          用于电子通讯的计算机程序对电子通讯的拦截或操纵）等公共服务因素或您自身因素（包括但不限于您操作不当、通过非学而思授权的方式使用本服务）或第三人因素（包括但不限于受到计算机病毒、木马
          或其他恶意程序、黑客攻击的破坏、顾客的错误下单等错误操作）。
        </p>
        <p class="second">
          4.4在学而思已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、缺陷、网络信息与数据安全、技术风险等因素。
        </p>
        <p class="second">
          4.5您知悉并理解，学而思将最大程度履行合理的注意义务，维护学而思数据准确性，但由于互联网技术因素等客观原因，
          学而思可能会出现网页显示信息滞后或差错现象，学而思将将在发现后尽快进行修复。
        </p>
        <p class="second">4.6 其他学而思无法控制或合理预见的情形。</p>
        <p>
          5.学而思仅对因学而思原因给用户造成的直接、实际损失依法承担相应的赔偿责任，不对任何间接损失、惩罚性赔偿承担责任。
        </p>
      </strong>
      <h2>四、隐私政策</h2>
      <p>本隐私政策将帮助您了解以下内容：</p>
      <p>1.平台如何收集和使用您的个人信息</p>
      <p>2.平台如何使用Cookie和同类技术</p>
      <p>3.平台如何共享、转让、公开披露您的个人信息</p>
      <p>4.平台如何保护您的个人信息</p>
      <p>5.平台如何处理未成年人的个人信息</p>
      <p>6.您的个人信息如何在全球范围转移</p>
      <p>7.您的个人信息变更途径</p>
      <p>8.本隐私政策如何更新</p>
      <h3>（一）个人信息收集及使用</h3>
      <p>1.收集信息类型及用途</p>
      <p>平台会出于本政策所述的以下目的，收集和使用您的个人信息：</p>
      <p class="second">
        1.1为成为学而思用户，便于平台为您提供服务，您需要提供<strong>手机号码</strong>作为基本注册及登录信息，以创建您的帐号、用户名和密码。
      </p>
      <p>
        在部分单项服务注册及登录过程中，如果您提供其他额外信息（您帐号所提供的<strong>年级、地区、在读学校、目标学校、昵称</strong>），
        将有助于平台给您提供个性化的推荐和更优的服务体验，但如果您不提供这些信息，并不会影响您使用好未来服务的基本功能。
        同时，依照相关法律法规的要求或者特定功能及服务需要，
        您在使用特定功能及服务（学生成绩诊断和评估、邮寄纸质讲义、紧急情况联系家长、表扬上墙、班级秀、个人秀、点名互动、课中的学生识别、书写主观题、
        老师在教学过程中得到学生的反馈信息、家长监课、学生课堂精彩片段)前，
        可能需要您提供其他信息（<strong>姓名、性别、身份证、护照、联系人手机号码、收货地址、头像、面部特征、笔迹、声纹、指纹、校内成绩与作业、课中视频</strong>）。
        如果您不提供上述信息，平台将不能向您提供相关的功能及服务。如果您仅需使用浏览、搜索及查看学而思官方主页及学而思开放平台等基本服务及介绍，您不需要注册成为平台的
        会员及提供上述信息。成为学而思用户后，客户可以对个人信息进行修改，如姓名、年级、地区、电话、头像、性别、联系人手机号码、收货地址、在读学校、目标学校。
      </p>
      <p class="second">
        1.2为向您提供更契合您需求的服务，您会向平台提供信息并将这些信息进行关联，这些功能和信息包括：
      </p>
      <p class="third">
        1.2.1产品预订/购买：您需要向学而思提供联系人信息（<strong>姓名、性别、电话号码</strong>）、
        <strong>地址信息</strong>（如涉及到需要邮寄教材、讲义等学习材料的服务时），
        以供学而思为您在具体产品提供长期班、短期班、精品课、讲座、在线课等录播课程、直播课程、小班面授、双师课堂等产品预订/购买服务。
      </p>
        当您在学而思旗下平台上使用配送/邮寄（教材、图书购买）服务时，您需要提供取\收货人的姓名、
        性别（用于配送人员联络时称呼您，如刘女士）、手机号码、收货地址、门牌号，以便于您的订单能够安全准确送达并完成。
      <p class="third">
        1.2.2信息发布：您在学而思旗下平台上主动对产品/服务进行评价或发布其他内容（如发表评论信息、完成学习任务）时，
        平台将收集您发布的信息，并展示您的昵称、头像和发布内容。如您选择以匿名方式发布评价信息时，平台将不展示您的昵称、
        头像。您还可以通过主动上传图片、视频等方式授权访问您的相机、照片和麦克风，以便于您通过拍照、拍视频、上传照片或上传视频等方式发布内容。
        当您需要关闭该功能时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。
      </p>
      <p class="third">
        1.2.3支付：您在学而思旗下平台上支付时，您可以选择学而思合作的第三方支付机构（如招商银行一网通、银联在线、微信支付、支付宝等支付通道）
        所提供的支付服务。支付功能本身并不收集您的个人信息，但平台需要将您的学而思订单信息及对账信息与这些支付机构共享以确认您的支付指令并完成支付。
      </p>
      <p class="third">
        1.2.4客服服务：当您与平台的客服取得联系时，平台的系统可能会记录您与客服之间的通讯记录，以及使用您的帐号信息以便核验身份；
        当您需要平台提供与您订单相关的客户服务时，平台可能会查询您的相关订单信息以便给予您适当的帮助和处理；当您需要客服协助您修改有关信息
        （如姓名、配送地址、联系方式）时，您可能还需要提供上述信息外的其他信息以便完成修改。
      </p>
      <p class="third">
        1.2.5代为购买学而思服务：您可以通过学而思旗下平台为其他人购买各类产品/服务，并提供该实际服务接收人的有关信息，您同意并确保此前请您已取得相关人的授权。
      </p>
      <p class="third">
        1.2.6账单管理为展示您帐号的订单信息，平台会收集您在使用平台服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。
        您在学而思生成的订单中，将可能包含您的身份信息、联络信息、地址信息、支付信息，这些都属于敏感信息，请您谨慎向他人展示或对外提供，
        如学而思需对外提供订单信息时，将取得您的授权，并尽到合理商业注意义务对您的信息进行去标识化处理以在最大化保护您的个人信息同时实现信息可用性。
      </p>
      <p class="second">
        1.3为向您提供更契合您需求的服务，平台会收集关于您使用产品、服务以及使用方式的信息并将这些信息进行关联，这些信息包括：
      </p>
      <p class="third">
        1.3.1设备信息：平台会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关软硬件特征信息（设备型号、
        操作系统版本、设备设置、唯一设备标识符）、设备所在位置相关信息（IP地址、GPS/北斗位置信息以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）。
      </p>
      <p class="third">
        1.3.2<strong>日志信息</strong>：当您使用平台的网站或客户端提供的产品或服务时，平台会自动收集您对平台服务的详细使用情况，作为有关网络日志保存，
        包括您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间、您访问的网页记录、通话状态信息。
      </p>
      <p class="third">
        1.3.3请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果平台将这类非个人信息与其他信息结合用于识别特定自然人身份，
        或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，平台会将该类个人信息做匿名化、
        去标识化处理。
      </p>
      <p class="third">
        1.3.4为展示您帐号的订单信息，平台会收集您在使用平台服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。
      </p>
      <p class="third">
        1.3.5当您与平台联系时，平台可能会保存您的通信/通话记录和内容或您留下的联系方式相关信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
      </p>
      <p class="third">
        1.3.6为能向您提供更优质的服务，同时为能确认交易状态及为您提供售后与争议解决服务，
        经您授权后平台会通过您选择的交易对象和交易直接涉及的第三方信息系统、支付机构等收集与交易进度相关的您的交易、支付相关信息，
        以便于平台处理您的订单并保证服务的顺利完成，或者更好地预防诈骗、刷单等恶意行为。平台会依据法律法规的要求以及与第三方的约定，
        以弹窗方式经您授权后从学而思的关联公司、合作伙伴获得您的有关信息，并对其信息来源的合法性进行确认后使用您的这些信息。
        如您在授权使用第三方帐号登录时，平台会从第三方获取您共享的帐号信息（如头像、昵称），并在您同意本隐私政策后、在您使用相关功能时，
        将您的第三方帐号与学而思帐号进行绑定。
      </p>
      <p class="second">1.3为您提供安全保障</p>
      <p>
        为预防、发现、调查欺诈、侵权、危害安全、非法或违反与平台或与平台关联公司的协议、政策或规则的行为，
        平台可能收集或整合您的用户信息、服务使用信息、设备信息、日志信息以及平台关联公司、合作伙伴取得您授权或依据法律共享的信息。
      </p>
      <p class="second">
        1.4学而思收集及使用上述信息的目的是为了更好地经营学而思产品和服务（包括但不限于向您提供个性化的服务），
        平台将基于本政策未载明的其他特定目的收集您的信息时，会事先征求您的同意。如平台停止运营学而思产品或服务，
        平台将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
      </p>
      <p>2. 信息使用方式</p>
      <p>
        收集您的信息是为了向您提供服务及提升服务质量，为了实现这一目的，您的信息将用于下列用途，如平台需将收集到的相关信息用于新的目的、
        范围或实际传输方式与本协议约定不一致时，平台将以App弹窗确认的方式通知到您并取得您的明示同意：
      </p>
      <p class="second">2.1向您提供您使用的学而思产品或服务，并维护、改进、优化这些服务及服务体验；</p>
      <p class="second">
        2.2为预防、发现、调查欺诈、侵权、危害安全、非法或违反与平台或与平台关联公司的协议、政策或规则的行为，保护您、其他用户或公众，
        平台或平台关联公司的合法权益，平台可能使用或整合您的用户信息、服务使用信息、设备信息、日志信息以及平台关联公司、
        合作伙伴取得您授权或依据法律共享的信息，来综合判断您帐号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施；
      </p>
      <p class="second">
        2.3平台可能会将您的信息进行处理或者与来自其他服务的信息结合起来，用于为了向您提供更加个性化的服务使用，向您推荐可能感兴趣的内容，
        包括但不限于向您发出产品和服务信息，或通过系统向您展示个性化的第三方推广信息，或者在征得您同意的情况下与学而思合作伙伴共享信息以便他们向您发送有关其产品和服务的信息；
      </p>
      <p class="second">
        2.4平台可能会收集您的订单信息、浏览信息、您的兴趣爱好（您可以在账户设置中选择）进行数据分析以形成间接用户画像，用来将您感兴趣的商品或服务信息展示给您。
      </p>
      <p class="second">2.5经您许可的其他用途。</p>
      <p>3.信息的储存</p>
      <p>
        平台将以以下形式储存收集到的相关个人信息：以加密方式存储在中华人民共和国大陆地区的服务器中。
        同时只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。
        例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。而平台判断前述期限的标准包括：
      </p>
      <p class="second">3.1完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；</p>
      <p class="second">3.2保证平台为您提供服务的安全和质量；</p>
      <p class="second">3.3您是否同意更长的留存期间；</p>
      <p class="second">3.4是否存在保留期限的其他特别约定。</p>
      <p>
        在您的个人信息超出保留期间后，平台会根据适用法律的要求删除您的个人信息，或使其匿名化处理。如因特殊情形无法按照相关要求删除的，平台将对该部分事项向您进行说明。
      </p>
      <h3>（二）Cookie 和同类技术使用</h3>
      <p>
        1.为使您获得更轻松的访问体验，您使用学而思产品或服务时，平台可能会通过采用各种技术收集和存储您访问学而思服务的相关数据，
        在您访问或再次访问学而思服务时,平台能识别您的身份，并通过分析数据为您提供更好更多的服务。
        包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入帐号信息的步骤，或者帮助判断您的帐号安全。这些数据文件可能是Cookie、Flash
        Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。
      </p>
      <p>
        2.请您理解，平台的某些服务只能通过使用Cookie才可得到实现。如果您的浏览器或浏览器附加服务允许，
        您可以修改对Cookie的接受程度或者拒绝学而思的Cookie，但拒绝学而思的Cookie在某些情况下您可能无法使用依赖于cookies的学而思服务的部分功能。
      </p>
      <p>
        3.网页上常会包含一些电子图像，称为“单像素 GIF 文件”或“网络
        beacon”，它可以帮助网站计算浏览网页的用户或访问某些cookie。平台会通过网络beacon收集您浏览网页活动信息，
        您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定。
      </p>
      <h3>（三）信息的共享、转让、公开披露</h3>
      <p>1. 共享</p>
      <p>平台不会与学而思服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</p>
      <p class="second">1.1在获取明确同意的情况下共享：获得您的明确同意后，平台会与其他方共享您的个人信息。</p>
      <p class="second">
        1.2在法定情形下的共享：平台可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
      </p>
      <p class="second">
        1.3与关联公司间共享：为便于平台基于关联帐号共同向您提供服务，推荐您可能感兴趣的信息或保护学而思关联公司或其他用户或公众的人身财产安全免遭侵害，
        您的个人信息可能会与平台的关联公司共享。平台只会共享必要的个人信息（如为便于您使用学而思帐号使用平台关联公司产品或服务，平台会向关联公司共享您必要的帐号信息），
        如果平台共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。您同意关联公司与学而思共享服务必要的相关信息。
        学而思将准确记录和保存个人信息的共享、转让的情况，包括共享、转让的日期、规模、目的，以及数据接收方基本情况。
      </p>
      <p class="second">
        1.4与授权合作伙伴共享：
        <strong>
          仅为实现本隐私政策中声明的目的，平台的某些服务将由平台和授权合作伙伴共同提供。平台可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。
        </strong>
        在您上网采购网站上的产品时，平台必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。平台仅会出于合法、正当、必要、特定、
        明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。<strong>平台的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。</strong>
      </p>
      <p class="second">
        1.5学而思服务含有到其他网站的链接。除法律另有规定外，学而思对其他网站的隐私保护措施不负任何责任。
        平台可能在任何需要的时候增加商业伙伴或共用品牌的网站，但是提供给他们的将仅是综合信息，平台将不会公开您的身份。
      </p>
      <p>2.转让</p>
      <p>平台不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <p class="second">2.1在获取明确同意的情况下转让：获得您的明确同意后，平台会向其他方转让您的个人信息。</p>
      <p class="second">
        2.2在学而思服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，
        如涉及到个人信息转让，平台会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则平台将要求该公司、组织和个人重新向您征求授权同意。
      </p>
      <p>3. 公开披露</p>
      <p>平台仅会在以下情况下，公开披露您的个人信息：</p>
      <p class="second">3.1获得您明确同意或基于您的主动选择，平台可能会公开披露您的个人信息；</p>
      <p class="second">
        3.2如果平台确定您出现违反法律法规或严重违反学而思相关协议规则的情况，
        或为保护学而思及其关联公司用户或公众的人身财产安全免遭侵害，
        平台可能依据法律法规或学而思相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及学而思已对您采取的措施。
      </p>
      <p>4.共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
      <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
      <p class="second">4.1与国家安全、国防安全有关的；</p>
      <p class="second">4.2与公共安全、公共卫生、重大公共利益有关的；</p>
      <p class="second">4.3与犯罪侦查、起诉、审判和判决执行等有关的；</p>
      <p class="second">4.4出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p class="second">4.5您自行向社会公众公开的个人信息；</p>
      <p class="second">4.6从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
      <p class="second">
        4.7根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，
        不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
      </p>
      <h3>（四）信息的保护</h3>
      <p>
        1.平台会采取各种预防措施来保护您的个人信息，以保障您的个人信息免遭丢失、盗用和误用，
        以及被擅自取阅、披露、更改或销毁。为确保您个人信息的安全，平台有严格的信息安全规定和流程，并有专门的信息安全团队在公司内部严格执行上述措施。
      </p>
      <p>
        2.学而思有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。
      </p>
      <p>
        3.平台会采取合理可行的措施，尽力避免收集无关的个人信息，并在限于达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期限或在法律的允许期限内。
      </p>
      <p>
        4.如发生个人信息安全事件后，平台将按照法律法规的要求并最迟不迟于30
        个自然日内向您告知：安全事件的基本情况和可能的影响、平台已采取或将要采取的处置措施、
        您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况平台将以邮件、信函、电话、推送通知等方式告知您，
        难以逐一告知个人信息主体时，平台会采取合理、有效的方式发布公告。同时，平台还将按照监管部门要求，上报个人信息安全事件的处置情况。
      </p>
      <p>
        5.互联网环境并非百分之百安全，尽管平台有这些安全措施，但请注意在互联网上不存在“完善的安全措施”，平台将尽力确保您的信息的安全性。
      </p>
      <h3>（五）未成年人保护</h3>
      <p>
        平台重视未成年人的信息保护，如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，
        并在征得您的父母或监护人同意的前提下使用平台的服务或向平台提供信息。
        对于经父母或监护人同意使用平台的产品或服务而收集未成年人个人信息的情况，平台只会在法律法规允许，
        父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。
        平台将遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，根据国家相关法律法规及本政策的规定保护未成年人的个人信息。
      </p>
      <h3>（六）您的个人信息如何在全球范围转移</h3>
      <p>
        原则上，平台在中华人民共和国境内运营中收集和产生的个人信息，存储在中国人民共和国境内。
        就中华人民共和国境外学而思用户使用学而思产品及服务过程中产生的个人信息，您同意回传存储在中国境内的服务器上，
        否则您无法使用现有学而思的产品及服务。在此类情况下，平台会确保您的个人信息得到在中华人民共和国境内足够同等的保护。
      </p>
      <h3>（七）信息变更</h3>
      <p>1.用户信息查看：您可以通过查看App的方式对您现有的注册及其他已提供的信息进行查看。</p>
      <p>
        2.用户信息变更：您可以在APP上进行个人信息的变更
        （包括手机号、姓名、头像、性别、地区，收货地址、年级、在读学校、目标学校、联系人手机号），
        如有任何问题，您可以通过学而思的在线服务或电话服务渠道联系平台，帮您解决问题。
      </p>
      <p>
        3.用户信息删除：您可以通过学而思的在线服务或电话服务渠道联系平台，提供相关信息后，平台会帮您删除用户信息。
        如平台停止运营或停止提供相关服务，平台将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，
        对所持有的个人信息进行删除或匿名化处理。
      </p>
      <p>
        4.用户信息授权撤回：平台每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策）。除此之外：
      </p>
      <p class="second">
        4.1您可以通过解除绑定、修改个人设置、删除相关信息等方式撤回部分授权，也可以通过关闭功能的方式撤销授权。
      </p>
      <p class="second">
        4.2当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。
      </p>
      <p>
        5.用户帐号注销：您可以通过学而思的客服电话联系平台并提供相关信息后，平台将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或使其匿名化处理。
      </p>
      <h3>（八）本隐私政策更新</h3>
      <p>
        学而思有权在必要时修改本政策条款，并以App弹窗确认的方式通知到您。您可以随时在本平台查阅修改后的最新版本政策。
        如您不同意修改后的政策，您有权终止对平台的授权。本政策更新后，如果您继续使用相应平台功能，即视为您已接受修改后的政策。
      </p>
      <p>
        对于重大变更，平台还会提供更为显著的通知（包括平台会通过在App内发布文章的方式进行意见征集、公告通知甚至向您提供弹窗提示）。
      </p>
      <p>本政策所指的重大变更包括但不限于：</p>
      <p>1.平台的服务模式发生重大变化。如处理用户信息的目的、用户信息的使用方式等；</p>
      <p>2.平台在控制权、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
      <p>3.用户信息共享、转让或公开披露的主要对象发生变化；</p>
      <p>4.平台负责处理用户信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
      <p>5.用户信息安全影响评估报告表明存在高风险时。</p>
      <h2>五、知识产权</h2>
      <p>
        1.学而思及其关联公司是本平台的知识产权权利人。本平台的一切著作权、商标权、专利权、商业秘密等知识产权，
        以及与本平台相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）
        均受中华人民共和国大陆地区法律法规和相应的国际条约保护，学而思或其关联公司享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
      </p>
      <p>
        2.未经平台书面同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行,
        或者被用于其他任何商业目的。所有以上资料或资料的任何部分仅可作为私人和非商业用途保存。
      </p>
      <h2>六、其他</h2>
      <p>1.本政策所有条款的标题仅为阅读方便，不作为本政策涵义解释或限制的依据。</p>
      <p>
        2.本政策任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本政策其余条款的有效性及可执行性。
      </p>
      <p>
        3.本政策可能存在包括中文、英文在内的多种语言的版本，如果存在中文版本与其他语言的版本相冲突的地方，以中文版本为准。
      </p>
      <p>
        4.针对某些特定的产品及服务，平台还将制定特定的隐私政策，并在向您提供这些特定的产品及服务之前加以说明。如相关特定的隐私政策与本隐私政策不一致的，适用该特定隐私政策。
      </p>
      <h2>七、法律适用与管辖</h2>
      <p>
        1.本政策之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律。如法律无相关规定的，参照商业惯例及/或行业惯例。
      </p>
      <p>
        2.您因使用学而思服务所产生及与学而思服务有关的争议，由学而思与您协商解决。协商不成时，任何一方均可向北京市海淀区人民法院提起诉讼。
      </p>
      <h2>八、与平台联系</h2>
      <p>
        当您有个人信息相关问题或其他的投诉、建议等，可以通过如下方式与平台联系，平台将尽快审核所涉及内容，并于15个工作日内对于您的问题、投诉、建议进行回复：
      </p>
      <p>平台运营主体名称：北京学而思教育科技有限公司</p>
      <p>注册地址：北京市海淀区北三环西路甲18号中鼎大厦A座1层102室</p>
      <p>联系地址：北京市海淀区北三环西路甲18号中鼎大厦A座1层102室</p>
      <p>联系电话：010-10108899</p>
    </div>
  </Dialog>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
  name: 'Agreement',
  components: {
    Dialog,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    visible: {
      get() {
        return this.active;
      },
      set(newVal) {
        this.$emit('update:active', newVal);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.agreementDialog /deep/.el-dialog {
  max-height: calc(100vh - 116px);
  height: 578px;
  text-align: left;
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  max-width: calc(100vw - 60px);
  border-radius: 6px;
  box-shadow:0px 0px 8px 0px rgba(0,0,0,0.3);
  ::-webkit-scrollbar{
    display:block;
    width: 6px;
    position: absolute;
    right: 10px;
  }/* 整体样式 */
  ::-webkit-scrollbar-track{}/* 轨道 */
  ::-webkit-scrollbar-thumb{
    width:6px;
    height:154px;
    background:rgba(192,192,192,1);
    border-radius:4px;
  }/* 滑块 */
  ::-webkit-scrollbar-track-piece{background-color:none}/* 不包含滑块的轨道区 */
  #agreement {
    height: 100%;
    overflow-y: overlay;
    padding-right: 23px;
  }
  .el-dialog__header {
    padding: 0;
    h1 {
      margin-top: 25px;
      margin-bottom: 0px;
    }
    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
      background: url("~@/assets/images/close.png");
      background-size: content;
      width: 18px;
      height: 18px;
    }
  }
  .el-dialog__body {
    padding: 20px 10px 28px 35px;
    box-sizing: border-box;
    height: 0;
    flex: 1 1 auto;
  }
  p {
    width: 100%;
    overflow-wrap: break-word;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;

    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:#333333;
    line-height:21px;

    &.indent{
      text-indent:2em
    }
  }
  .second {
    text-indent:1em;
  }
  .third {
    text-indent:2em;
  }
  h1 {
    height:33px;
    font-size:24px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:33px;
    text-align:center;
    margin-block-start: 20px;
    margin-block-end: 20px;
  }
  h2 {
    // font-size:20px;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:#333333;
    line-height:21px;
  }
}
</style>
